import { useSelector } from 'react-redux';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getOriginalDirectSalesCampaign } from 'modules/api/directSalesCampaign';
import { transformDirectSalesBookingResponse } from 'components/pages/Planner/hooks/utils/transformDirectSalesCampaignResponses';
import useUpdateDirectSalesCampaign from 'components/pages/Planner/hooks/DirectSalesPlannerActions/useUpdateDirectSalesCampaign';
import { getMarketId } from 'store/publisher/selectors';
import { DuplicateCampaignProps, UseCampaignDuplication } from './useCampaignDuplication.types';

const useCampaignDuplication = (): UseCampaignDuplication => {
  const { duplicateCampaign } = useUpdateDirectSalesCampaign();

  const marketId = useSelector(getMarketId);

  const handleDuplicateCampaign = async ({
    selectedDate,
    areCancelledLinesIncluded,
    campaignId,
    onComplete,
  }: DuplicateCampaignProps): Promise<void> => {
    try {
      const result = await getOriginalDirectSalesCampaign(campaignId, marketId, cancelFunctions);
      const { lines: linesData } = transformDirectSalesBookingResponse(result);

      const {
        campaign: {
          body: { campaignDefinition: campaignDefinitionData },
          header: { salesPerson, salesTeam, adminPerson },
        },
      } = result;

      onComplete();
      await duplicateCampaign({
        campaignStartDate: selectedDate,
        areCancelledLinesIncluded,
        campaignDefinitionData: { ...campaignDefinitionData, salesPerson, salesTeam, adminPerson },
        linesData,
      });
      // eslint-disable-next-line no-empty
    } catch {}
  };

  return async (props: DuplicateCampaignProps) => handleDuplicateCampaign(props);
};

export default useCampaignDuplication;
